import React, { useMemo } from 'react';
import { REACTION_METADATA, IS_PENDING } from '../../data-hooks';
import { ReactionIcon } from '../../reaction-icon/reaction-icon';
import { getReactionName } from '../../utils/reaction-converters';
import { getValidReactions } from '../../utils/get-valid-reactions';
import { resolveMainReactionName } from '../../default-reactions';
import { classes, st } from './emotions-metadata.st.css';
import classNames from 'classnames';
import cssVars from '../../styles/css-vars.scss';
export const EmotionsMetadata = ({ reactions, onClick, config, t, reactionsToShowCount = 3, isMobile, className, isPending, }) => {
    const validReactions = useMemo(() => {
        return getValidReactions(reactions, config);
    }, [reactions, config]);
    const totalCount = validReactions.reduce((total, reaction) => total + reaction.total, 0);
    const reactionsToShow = reactions.filter((r) => r.total > 0).slice(0, reactionsToShowCount);
    const mainReaction = resolveMainReactionName(config.mainEmotion);
    return totalCount && reactionsToShow.length ? (React.createElement("button", { "data-hook": classNames(REACTION_METADATA, isPending && IS_PENDING), className: st(classes.root, { isMobile, isPending }, cssVars.reactionsContainer, className), onClick: onClick, "aria-label": t('reaction-metadata.aria-label', { count: totalCount }) },
        React.createElement("div", { className: classes.reactionContainer }, reactionsToShow.map((reaction) => (React.createElement(ReactionIcon, { className: classes.reaction, reactionName: getReactionName(reaction.reactionCode, mainReaction) })))),
        React.createElement("span", null, totalCount))) : null;
};
//# sourceMappingURL=emotions-metadata.js.map